import React from 'react';
import { fmtK, fmtT, DONUT_COLORS } from './theme';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

export const DonutChart = ({ data, metric = 'val', title, tag }) => {
  if (!data || !data.length) return null;

  const total = data.reduce((a, c) => a + (metric === 'val' ? c.val : c.qty), 0);

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.[0]) return null;
    const d = payload[0].payload;
    const v = metric === 'val' ? d.val : d.qty;
    const pct = total > 0 ? ((v / total) * 100).toFixed(1) : '0';
    return (
      <div className="bg-dash-panel border border-dash-line rounded-lg px-3 py-2 text-xs font-mono">
        <div className="text-dash-ink font-bold">{d.name}</div>
        <div className="text-dash-mut">{metric === 'val' ? fmtK(v) : fmtT(v)} ({pct}%)</div>
      </div>
    );
  };

  return (
    <div className="bg-dash-panel border border-dash-line rounded-xl p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-grotesk font-semibold text-dash-ink">{title}</h3>
        {tag && <span className="text-[10px] font-mono uppercase text-dash-mut border border-dash-line rounded px-2 py-0.5">{tag}</span>}
      </div>
      <div className="h-52 relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey={metric === 'val' ? 'val' : 'qty'}
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius="55%"
              outerRadius="85%"
              strokeWidth={1}
              stroke="var(--dash-bg)"
            >
              {data.map((_, i) => (
                <Cell key={i} fill={DONUT_COLORS[i % DONUT_COLORS.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="text-center">
            <div className="text-lg font-mono font-bold text-dash-ink">{metric === 'val' ? fmtK(total) : fmtT(total)}</div>
            <div className="text-[10px] font-mono uppercase text-dash-mut">{metric === 'val' ? 'TOTAL FOB' : 'TOTAL VOL'}</div>
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-col gap-[5px] mt-1.5">
        {data.map((d, i) => {
          const v = metric === 'val' ? d.val : d.qty;
          const pct = total > 0 ? (v / total) * 100 : 0;
          return (
            <div key={d.name + i} className="flex items-center gap-2 text-xs rounded px-0.5 py-0.5">
              <span className="w-[9px] h-[9px] rounded-sm shrink-0" style={{ background: DONUT_COLORS[i % DONUT_COLORS.length] }} />
              <span className="flex-1 min-w-0 truncate text-dash-ink" title={d.name}>{d.name}</span>
              <span className="font-mono text-dash-mut text-[11px] shrink-0">{pct.toFixed(1)}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
